import axios from "axios";

const BASE = "/api";

const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.response.use(

  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      return Promise.resolve({ data: null });
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;

  if (detail == null) return err?.message || "حدث خطأ غير متوقع";

  if (typeof detail === "string") return detail;

  if (Array.isArray(detail))
    return detail
      .map((e) =>
        e && typeof e.msg === "string"
          ? e.msg
          : JSON.stringify(e)
      )
      .join(" ");

  if (detail && typeof detail.msg === "string")
    return detail.msg;

  return String(detail);
}

export default api;
